import { KitchenCollection } from 'modules/collections';
import { BATHROOM_CDN_PATH } from '../../../bathroom-constants';
import { ALL_IMAGE_LIST_PRESET } from './new-bathroom-gallery-constants';
import { ImagePreset } from './new-bathroom-gallery-types';

const prepareImageList = (imagePresetList: ImagePreset[], style: string): Partial<KitchenCollection>[] => (
  imagePresetList.map((preset, index: number) => ({
    displayedName: preset.displayedName,
    productUrl: `/proekty/${preset.productName}/`,
    mediaMainPhoto: preset.mediaMainPhoto.map((photo: string) => {
      const styleFolder = style === 'all' && index === 0 ? 'all' : preset.style;
      const subPath = index === 0 ? `large-card/${styleFolder}` : styleFolder;
      return `${BATHROOM_CDN_PATH}/gallery/${subPath}/${preset.productName}/${photo}`;
    })
  }))
);

export const getImageList = (style: string) => {
  if (style === 'all') {
    return prepareImageList(ALL_IMAGE_LIST_PRESET.sort((a, b) => {
      if (a.rating === undefined && b.rating === undefined) return 0;
      else if (a.rating === undefined) return 1;
      else if (b.rating === undefined) return -1;
      else return a.rating - b.rating;
    }), style)
  }

  return prepareImageList(ALL_IMAGE_LIST_PRESET.filter(preset => preset.style === style), style);
}